// App entry point
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove console logs in production for cleaner output
if (import.meta.env.PROD) {
  console.log = () => {};
  console.debug = () => {};
  // Keep console.warn and console.error for debugging production issues
}

// Initialize Web Vitals tracking (async, non-blocking)
import('./lib/webVitals').then(({ initWebVitals }) => {
  initWebVitals();
}).catch(() => {
  // Silently fail - web vitals are non-critical
});

// Register service worker for caching (production only)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silently fail - SW is an enhancement, not critical
    });
  });
}

createRoot(document.getElementById("root")!).render(<App />);
